import { Component, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FormControl, FormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DateAdapter, MatOption } from '@angular/material/core';

import { faCalendar, faFilePdf, faEye } from '@fortawesome/free-solid-svg-icons';

import { Filter } from './filter';
import { Order } from './order';
import { ReportsService } from '../../services/reports.service';
import { DomSanitizer } from '@angular/platform-browser';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ResultsDialog } from './modals/results.component';
import { AuthService } from 'src/app/services/auth.service';
import { InfoDialog } from './modals/info.component';
import { PdfDialog } from './modals/pdf.component';
import { HistoryDialog } from './modals/history.component';
import { SelectionDialog } from '../utils/group-selection/selection.component';
import { GroupsService } from 'src/app/services/groups.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UserService } from 'src/app/services/user.service';
import { SelectionModel } from '@angular/cdk/collections';
import { MatIconRegistry } from '@angular/material/icon';
import { report } from 'process';
import { User } from '../users/user';
import { MatSelect } from '@angular/material/select';
import { environment } from '../../../environments/environment'



@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.css'],
  providers: [NgbModalConfig, NgbModal]
})
export class ReportsComponent implements OnInit {

  env = environment;
  displayedColumns: string[] = ['select', 'orderDate', 'doctor', 'warning', 'id', 'patientName', 'sex', 'service', 'state', 'actions'];
  patientColumns: string[] = ['select', 'name', 'surname', 'sex', 'birthdate', 'fiscalCode', 'healthCode'];
  @ViewChild('orderPaginator', { static: false }) paginator: MatPaginator;
  @ViewChild('patientPaginator', { static: false }) paginatorPatients: MatPaginator;
  @ViewChildren('patientOrdersPaginator') paginatorPatientsOrders: QueryList<MatPaginator>;

  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild('patientSort', { static: false }) patientSort: MatSort;
  @ViewChildren('patientOrdersSort') patientOrdersSort: QueryList<MatSort>;



  dataSource = new MatTableDataSource<Order>();
  patientSource = new MatTableDataSource<any>();

  orderSelection = new SelectionModel<Order>(true, []);

  /** Whether the number of selected elements matches the total number of rows. */
  isAllOrderSelected() {
    const numSelected = this.orderSelection.selected.length;
    const numRows = this.dataSource.filteredData.filter(order => order.reportState > 0).length;
    return (numSelected === numRows) && numSelected > 0;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  orderMasterToggle(masterToggle) {
    if (this.orderSelection.selected.length == 0) masterToggle.checked = false;
    this.isAllOrderSelected() ?
      this.orderSelection.clear() :
      this.dataSource.filteredData.forEach(row => {
        if (row.reportState > 0)
          this.orderSelection.select(row)
      });
  }

  /** The label for the checkbox on the passed row */
  checkboxOrderLabel(row?: Order): string {
    if (!row) {
      return `${this.isAllOrderSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.orderSelection.isSelected(row) ? 'deselect' : 'select'} row`;
  }


  filter: Filter = new Filter();
  searchParams: FormGroup;
  private _orders: any[] = [];
  patients: any;
  minDate: Date;
  maxDate: Date;
  all: any = "todos";

  wards;
  pdf;
  results;

  //FLAGS
  private _filterActive: boolean;
  private _newData: boolean;
  private _newPatients: boolean;
  private _newPatientsData: boolean;
  private _reportSelected: boolean;
  private _patientSelected: boolean;
  private _historySelected: boolean;

  public get filterActive(): boolean {
    return this._filterActive;
  }
  public set filterActive(value: boolean) {
    this._filterActive = value;
  }

  filterService;
  filterState;


  public set patientSelected(value: boolean) {
    this._patientSelected = value;
  }

  public get newData(): boolean {
    return this._newData;
  }
  public set newData(value: boolean) {
    this._newData = value;
  }

  public get newPatients(): boolean {
    return this._newPatients;
  }
  public set newPatients(value: boolean) {
    this._newPatients = value;
  }

  public get newPatientsData(): boolean {
    return this._newPatientsData;
  }
  public set newPatientsData(value: boolean) {
    this._newPatientsData = value;
  }
  public get reportSelected(): boolean {
    return this._reportSelected;
  }
  public set reportSelected(value: boolean) {
    this._reportSelected = value;
  }

  public get historySelected(): boolean {
    return this._historySelected;
  }
  public set historySelected(value: boolean) {
    this._historySelected = value;
  }

  serviceFilter = new FormControl();
  stateFilter = new FormControl();
  patientFilter = new FormControl();

  filteredValues = {
    patientName: '', service: '', state: ''
  };

  ngOnInit(): void {
    this.setFilters();
  }

  setFilters(): void {
    this.filteredValues = {
      patientName: '', service: '', state: ''
    };

    this.serviceFilter = new FormControl();
    this.stateFilter = new FormControl();
    this.patientFilter = new FormControl();

    this.serviceFilter.valueChanges.subscribe((serviceFilterValue) => {
      this.filteredValues['service'] = serviceFilterValue;
      this.dataSource.filter = JSON.stringify(this.filteredValues);
      this.orderSelection.clear();
    });

    this.stateFilter.valueChanges.subscribe((stateFilterValue) => {
      //this.filteredValues['state'] = stateFilterValue;
      //this.dataSource.filter = JSON.stringify(this.filteredValues);
      this.dataSource.data = this.orders.filter(order => order.state == stateFilterValue)
      this.orderSelection.clear();
    });

    this.patientFilter.valueChanges.subscribe((patientFilterValue) => {
      this.filteredValues['patientName'] = patientFilterValue;
      this.dataSource.filter = JSON.stringify(this.filteredValues);
      this.orderSelection.clear();
    });

    this.withReports = true;
    this.filterWithReport();

    this.dataSource.filter = '';
  }

  withReports = false;
  filterWithReport(patient?) {
    this.withReports = !this.withReports;
    this.orderSelection.clear();
    if (!patient)
      if (this.withReports) {
        this.dataSource.data = this.orders.filter(order => order.reportState >= 1);
      } else {
        this.dataSource.data = this.orders;
      }
    else {
      if (this.withReports) {
        this.dataSource.data = this.dataSource.data.filter(order => order.reportState >= 1);
      } else {
        this.dataSource.data = this.filterOrders(patient);
      }
    }
  }

  get orderWithReports() {
    return this.orders.filter(order => order.reportState >= 1).length > 0;
  }

  customPredicate = (data: any, filter: string): boolean => {
    let searchString = JSON.parse(filter);

    return data.service.toString().trim().indexOf(searchString.service) !== -1 &&
      data.state.toString().trim().toLowerCase().indexOf(searchString.state.toLowerCase()) !== -1 &&
      data.patientName.toString().trim().toLowerCase().indexOf(searchString.patientName.toLowerCase()) !== -1;
  };

  user: User;

  group;

  constructor(private service: ReportsService, private router: Router,
    config: NgbModalConfig,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer,
    private adapter: DateAdapter<any>,
    private snackBar: MatSnackBar,
    public dialog: MatDialog,
    private auth: AuthService,
    private groupsService: GroupsService,
    private userService: UserService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer) {


    this.filterActive = false;
    this.newData = false;
    this.newPatients = false;
    this.newPatientsData = false;
    this.reportSelected = false;
    this.patientSelected = false;
    this.historySelected = false;

    this.matIconRegistry.addSvgIcon("doctor",
      this.domSanitizer.bypassSecurityTrustResourceUrl("./assets/doctor.svg"));
    this.matIconRegistry.addSvgIcon("history",
      this.domSanitizer.bypassSecurityTrustResourceUrl("./assets/history.svg"));


    this.user = this.userService.getUser();
    this.group = this.userService.getActiveGroup('report');

    if (this.group == null) {
      this.dialog.open(SelectionDialog, {
        data: { groupType: 'report' },
        width: '40%',
        disableClose: true
      });

    } else {
      this.updateData();
    }

    this.userService.updateUser().subscribe(
      (newUser) => {
        this.user = newUser
        this.group = this.userService.getActiveGroup('report');
        this.updateData();
        this.clean();

      }
    )


    /*this.groupsService.getGroup()
      .pipe(takeUntil(this.onDestroy))
      .subscribe(
        (wards) => {
          console.log(wards)
          //this.group = group;
          this.wards = wards
         // this.filter.group = this.group.id;

        })*/


    // customize default values of modals used by this component tree
    config.backdrop = 'static'; // VER SI SE BORRA
    config.keyboard = false; // IDEM 

    // CONFIG DE DATEPICKER
    this.adapter.setLocale('es');
    this.maxDate = new Date();
  }

  updateData() {
    this.wards = this.group?.wards //.sort((a, b) => (a.wardDescription > b.wardDescription) ? 1 : ((b.wardDescription > a.wardDescription) ? -1 : 0));
    this.filter.wards = this.group?.wards;
    this.filter.group = this.group.id;
    this.filter.startDate = new Date();
    this.filter.endDate = new Date();
    this.filter.searchOnlyByNameOrSurname = this.userService.getSystemProperty("search.patient.only.by.name.or.surname")
    this.filter.minDate = this.group.minStartDateSearch;
    if (this.group.minStartDateSearch != 0) {
      this.minDate = new Date();
      this.minDate.setMonth(this.minDate.getMonth() - this.group.minStartDateSearch);
    } else {
      this.minDate = new Date(0);
    }
  }


  private readonly onDestroy = new Subject<void>();

  ngOnDestroy() {
    this.onDestroy.next();
  }


  public get orders(): Order[] {
    return this._orders.map((order, i) => ({
      index: i, state: this.stateDescription(order),
      service: order.ward.wardDescription, ...order,
      reportState: this.reportState(order)
    }));
  }

  public set orders(value: Order[]) {
    this._orders = value;
  }


  open(content) {
    this.modalService.open(content, { size: 'lg', backdrop: 'static' });
  }

  selectWard() {
  }

  search(): void {
    if (this.filter.hasPatient()) {
      this.searchPatients();
    } else {
      this.searchOrders();
    }
  }

  /* BUSQUEDA DE PACIENTES */
  onePatient: boolean = false;
  searchPatients(): void {
    this.onePatient = false;
    this.service.getPatients(this.filter)
      .subscribe((data) => {
        data = data.map((patient, i) => ({ index: i, selected: false, ...patient }))
        this.patientSource = new MatTableDataSource<any>(data);
        this.patientSource.paginator = this.paginatorPatients;
        this.patientSource.paginator._intl.itemsPerPageLabel = "Pacientes por página: "
        this.patientSource.sortingDataAccessor = (item, property) => {
          switch (property) {
            case 'birthdate': return parseDateGetTime(item.birthdate);
            default: return item[property]

          }
        };
        this.patientSource.sort = this.patientSort;
        if (data.length == 1) {
          this.selectPatient(data[0], 0);
          this.searchPatientsOrders()
        } else if (data.length == 0) {
          this.snackBar.open("No se encontró ningún paciente", "x", {
            duration: 2000,
          });
        } else {
          this.newPatients = true;
        }
      });
  }

  searchOrders(): void {

    this.service.getOrders(this.filter)
      .subscribe((data: any) => {
        if (data.length > 0) {
          this.newData = true;
          this.newPatients = false;
          this.orders = data//.sort((a, b) => parseDateGetTime(b.orderDate) - parseDateGetTime(a.orderDate));
          this.dataSource = new MatTableDataSource<Order>(this.orders);
          this.dataSource.filterPredicate = this.customPredicate;
          this.dataSource.paginator = this.paginator;
          this.dataSource.paginator._intl.itemsPerPageLabel = "Solicitudes por página: "
          this.dataSource.sortingDataAccessor = (item, property) => {
            switch (property) {
              case 'orderDate': return parseDateGetTime(item.orderDate);
              default: return item[property]

            }
          };

          this.dataSource.sort = this.sort;
          this.filterService = [... new Set(this.dataSource.data.map(order => order.service))]
          this.filterService.length == 1 ? this.filterService = 1 : '';
          this.filterState = [... new Set(this.dataSource.data.map(order => order.state))]
          this.filterState = this.orderFilterState(this.filterState)
          this.filterState.length == 1 ? this.filterState = 1 : '';


        } else {
          this.snackBar.open("No hay resultados", "x", {
            duration: 2000,
          });
        }
      });

  }

  cleanDate() {
    this.filter.startDate = undefined;
    this.filter.endDate = undefined;
  }

  filterOrdered = new Array();
  orderFilterState(filterState) {
    this.filterOrdered = ["Pre ingresada", "Ingresada", "En curso", "Finalizada"];
    return this.filterState = this.filterOrdered.filter(x => this.filterState.includes(x));
  }

  searchPatientsOrders(): void {
    if (this.patientSource.data.length != 0) {
      //this.patients = this.patientSource.data.filter(patient => patient.selected);                  
      this.patients = this.selection.selected;
      this.filter.patientIds = this.patients.map(patient => patient.id);
    }

    this.service.getOrders(this.filter)
      .subscribe((data: any) => {
        this.cleanDate();
        if (data.length > 0) {
          this.newPatients = false;
          this.newPatientsData = true;
          this.orders = data//.sort((a, b) => parseDateGetTime(b.orderDate) - parseDateGetTime(a.orderDate));

          if (this.patients.length == 1) {
            this.showPatientOrders(this.patients[0], 0)
            this.onePatient = true;

          }

        } else {
          this.snackBar.open("No hay resultados", "x", {
            duration: 2000,
          });
        }
      });
  }

  history;
  searchPatientHistory(patient: any): void {
    this.filter.patientIds = [patient.id];
    this.service.getHistory(this.filter, this.group.patientHistoric)
      .subscribe((data: any) => {
        if (data.length > 0) {
          //this.orders = data.data.orders.sort((a, b) => parseDateGetTime(b.orderDate) - parseDateGetTime(a.orderDate));
          this.history = data.map(order => ({ ...order, reportState: this.reportState(order) }))//.sort((a, b) => parseDateGetTime(b.orderDate) - parseDateGetTime(a.orderDate));
          this.dialog.open(HistoryDialog, {
            data: {
              orders: this.history,
              patient,
              group: this.group
            }
          });
        } else {
          this.snackBar.open("No hay resultados", "x", {
            duration: 2000,
          });
        }
      });
  }

  clean() {
    this.filter = new Filter;
    this.allSelectedWard = true;
    this.filter.wards = this.group.wards;
    this.filter.group = this.group.id;
    this.allSelectedState = true;
    this.filter.minDate = this.group.minStartDateSearch;
    this.filter.searchOnlyByNameOrSurname = this.userService.getSystemProperty("search.patient.only.by.name.or.surname");
    this.filter.startDate = new Date();
    this.filter.endDate = new Date();
    this.patientSource = new MatTableDataSource<any>(); // para vaciar si hubo pacientes seleccionados
    this.selection.clear();
    this.newData = false;
    this.newPatients = false;
    this.newPatientsData = false;
    this.patientSelected = false;
    this.historySelected = false;
    this.withReports = false;
    this.patients = undefined;
    this.setFilters();
    this.clearPatientOrders();
    this.selectedRow = -1;

  }

  reports: number = 0;
  selectOrder(order: Order) {
    if (order.reportState > 0) {
      this.orderSelection.toggle(order)
    }
  }

  selection = new SelectionModel<any>(true, []);

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.patientSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    if (this.isAllSelected()) {
      this.selection.clear()
    }
    else {
      this.patientSource.data.forEach(row => {
        this.selection.select(row)
      });
    }
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: any): string {

    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }

  public get patientSelected(): boolean {
    return this.selection.selected.length > 0;
  }

  n_patients: number = 0;
  selectPatient(patient: any, index: number) {
    this.selection.toggle(patient);
    /*this.patientSource.data[index].selected = !this.patientSource.data[index].selected;
    this.patientSource.data[index].selected ? this.n_patients++ : this.n_patients--;
    this.n_patients == 0 ? this.patientSelected = false : this.patientSelected = true;*/

  }

  viewReport(order) {
    const obj = {
      groupId: this.group.id,
      groupType: 'report',
      reportType: 'report',
      generationType: this.userService.getSystemProperty('report.generation')
    };
    obj['reportRequest'] = [{
      orderId: order.orderId,
      lastReportId: order.lastReportId == -1 ? null : order.lastReportId,
      orderDate: order.orderDate,
      source: order.source,
      patientId: order.patientId
    }];

    this.service.getReports(obj).subscribe((resp) => {
      // const fileURL = URL.createObjectURL(resp);
      // window.open(fileURL, '_blank');
      if (resp) {
        this.pdf = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(resp));
        this.dialog.open(PdfDialog, {
          width: '80%',
          height: '89%',
          data: this.pdf
        });
      } else {
        this.snackBar.open('El informe seleccionado aún no está disponible', 'x', {
          duration: 2000,
        });
      }
    });
  }

  viewReports() {

    const obj = {
      groupId: this.group.id,
      groupType: 'report',
      reportType: 'report',
      generationType: this.userService.getSystemProperty('report.generation')
    };
    obj['reportRequest'] = this.orderSelection.selected.map(order => {
      const obj = {
        orderId: order.orderId,
        lastReportId: order.lastReportId == -1 ? null : order.lastReportId,
        orderDate: order.orderDate,
        source: order.source,
        patientId: order.patientId
      };

      return obj;
    });

    this.service.getReports(obj).subscribe((resp) => {
      if (resp) {
        const fileURL = URL.createObjectURL(resp);
        //window.open(fileURL, '_blank');
        this.pdf = this.sanitizer.bypassSecurityTrustResourceUrl(fileURL);
        this.dialog.open(PdfDialog, {
          width: '80%',
          height: '89%',
          data: this.pdf
        });
      } else {
        this.snackBar.open('Los informes seleccionados aún no están disponibles', 'x', {
          duration: 2000,
        });
      }
    });
  }

  viewPatientsReports(patient) {
    const obj = {
      groupId: this.group.id,
      groupType: 'report',
      reportType: 'report',
      generationType: this.userService.getSystemProperty('report.generation')
    };
    obj['reportRequest'] = this.filterOrders(patient).filter(order => order.reportState > 0).map(order => {
      const obj = {
        orderId: order.orderId,
        lastReportId: order.lastReportId,
        orderDate: order.orderDate,
        source: order.source,
        patientId: order.patientId
      };

      return obj;
    });

    this.service.getReports(obj).subscribe((resp) => {

      if (resp != null) {
        const fileURL = URL.createObjectURL(resp);
        //window.open(fileURL, '_blank');
        this.pdf = this.sanitizer.bypassSecurityTrustResourceUrl(fileURL);
        this.dialog.open(PdfDialog, {
          width: '80%',
          height: '89%',
          data: this.pdf
        });
      } else {
        this.snackBar.open("Los informes aún no están disponibles", "x", {
          duration: 2000,
        });
      }

    });
  }

  groupsId;
  viewResults(order: Order) {
    this.service.getResults(order).subscribe((resp) => {
      this.groupsId = [... new Set(resp.map(res => res.groupId))]
      // const fileURL = URL.createObjectURL(resp);
      // window.open(fileURL, '_blank');
      this.results = this.processResults(resp);
      this.dialog.open(ResultsDialog, {
        data: {
          results: this.results,
          state: order.orderState,
          order_id: order.orderId,
          order_date: order.orderDate,
          group: this.group,
          patient: {
            id: order.patientId,
            age: order.patientAge,
            birthdate: order.patientBirthdate,
            nameSurname: order.patientName,
            sex: order.patientSex,
            fiscalCode: order.patientFiscalCode,
            healthCode: order.patientHealthCode,
            patientId: order.patientId
          },
        },
      });
    });
  }

  processResults(results) {
    /*let rootId = '';
    for ( let i = 0; i < results.length; ++i) {
      if (results[i].testId != results[i].testRootId && results[i].testRootId != rootId) {
        rootId = results[i].testRootId;
        results.splice(i, 0 , {testDescription: results[i].testRootDescription, isBold: true, groupId: results[i].groupId});
      } else if (results[i].testId == results[i].testRootId) {
        results[i].isBold = true;
      }
    }*/

    let lastR = "";
    results.forEach(result => {
      if (result.type == "R") {
        lastR = result.testId;
      } else {
        if (result.type == "M") {
          result['RTestId'] = lastR;
        }
      }
    })

    results = results.map(
      result => ({ ...result, referenceValueMin: parseFloat(result.referenceValueMin), referenceValueMax: parseFloat(result.referenceValueMax) })
    )


    let rootIds = new Set(results.map(result => result.testRootId));
    let result = new Array();
    rootIds.forEach(
      (root) => {
        let tests = results.filter(result => result.testRootId == root);
        result.push(
          {
            rootId: root,
            rootDescription: tests[0].testRootDescription,
            groupId: tests[0].groupId,
            specimenDescription: tests[0].specimenDescription,
            tests: tests.filter(test => test.type == "R"),
          }
        )

        result[result.length - 1].tests?.forEach(
          test => {
            let micro = tests.filter(res => res.type == "M" && res.RTestId == test.testId);
            micro.forEach(mic => {
              mic['anti'] = results.filter(res => res.testRootId == test.testRootId && res.type == "A" && res.microId == mic.microId);
            });
            test['micro'] = micro;

          }
        )

      }
    )

    /*result.forEach(
      res => {
        res.micro.forEach(
          test => {
            test['anti'] =  results.filter(result => result.testRootId == res.rootId && result.type == "A" && result.microId == test.microId);
          }
        )
      }
    )*/

    //console.log(result);
    return result;
  }

  filteredResults;
  filterResults(index) {
    const group = this.groupsId[index - 1]
    this.filteredResults = this.results.filter(result => result.groupId == group);
  }

  status = 0; // 0 - cargando // 1 - listo // 2 -vacia
  showPatientOrders(patient, i) {
    this.status = 0;
    const orders = this.filterOrders(patient)
    this.withReports = false;
    this.orderSelection.clear();

    if (orders.length == 0) {
      this.status = 2;
    } else {
      this.dataSource = new MatTableDataSource<Order>(orders);
      this.dataSource.paginator = this.paginatorPatientsOrders.toArray()[i];
      this.dataSource.sort = this.patientOrdersSort.toArray()[i];
      this.dataSource.sortingDataAccessor = (item, property) => {
        switch (property) {
          case 'orderDate': return parseDateGetTime(item.orderDate);
          default: return item[property]

        }
      };
      
      this.dataSource.paginator._intl.itemsPerPageLabel = "Solicitudes por página: "

      this.status = 1;
    }

  }

  filterOrders(patient) {
    return this.orders.filter(order => order.patientId == patient.id);
  }

  viewPatientList() {
    this.newPatients = true;
    this.newPatientsData = false;
    this.selectedRow = -1;
    this.clearPatientOrders();
  }

  clearPatientOrders() {
    this.orderSelection.clear();
  }

  patient: any;
  showPatientInfo(patient, modal) {
    this.patient = patient;
    this.open(modal)
  }

  viewInfo(order): void {

    this.service.getInfo(order).subscribe(
      (resp) => {
        if (resp.length > 0)
          this.dialog.open(InfoDialog, {
            data: resp,
            width: '50%'
          });
        else {
          this.snackBar.open("Sin eventos", "x", {
            duration: 2000,
          });
        }
      }
    )

  }

  showMenu(event) {
  }

  public stateDescription(order: any): string {

    let reportGeneration = this.user.systemProperties.filter(elem => elem.parameterId == "report.generation")[0]?.parameterValue;

    let state;
    if (order.orderState == 0) {
      state = 'Pre ingresada';
    } else if (order.orderState == 1) {
      state = 'Ingresada';
    } else if (order.orderState >= 2 && order.orderState <= 6) {
      state = 'En curso';
    }
    else if (order.orderState == 7) {
      if (reportGeneration == 'PDF')
        state = "En curso";
      else if (reportGeneration == 'CDA')
        state = "Finalizada";
    }
    else if (order.orderState >= 8) {
      if (order.allResultsCanceled)
        state = "Anulada";
      else state = "Finalizada";
    }

    return state;
  }

  selectedRow = -1;

  openedPatient(i) {
    this.selectedRow = i;

  }

  reportState(order) {
    let report = { generation: null, partial: null }
    report.generation = this.user.systemProperties.filter(elem => elem.parameterId == "report.generation")[0]?.parameterValue;
    report.partial = this.group.partialReport;

    if (report.generation == 'PDF') {
      if (order.lastReportId == -1) {
        return 0;
      } else {
        if (report.partial == 1) {
          return order.orderState >= 8 ? 2 : 1;
        } else {
          return order.orderState >= 8 ? 2 : 0;
        }
      }
    } else if (report.generation == 'CDA') {
      if (report.partial == 1) {
        return order.orderState >= 7 ? 2 : order.orderState >= 5 ? 1 : 0;
      } else {
        return order.orderState >= 7 ? 2 : 0;
      }
    }

  }

  @ViewChild('selectWard') selectionWard: MatSelect;
  @ViewChild('selectState') selectionState: MatSelect;

  allSelectedWard = true;
  allSelectedState = true;

  toggleAllWardSelection(selection) {
    if (this.allSelectedWard) {
      selection.options.forEach((item: MatOption) => item.select());
    } else {
      selection.options.forEach((item: MatOption) => item.deselect());
    }
  }

  toggleAllStateSelection(selection) {
    if (this.allSelectedState) {
      selection.options.forEach((item: MatOption) => item.select());
    } else {
      selection.options.forEach((item: MatOption) => item.deselect());
    }
  }
  stateChanged() {
    if (this.filter.orderState.length < this.selectionState.options.length) {
      this.allSelectedState = false;
    } else {
      this.allSelectedState = true;

    }
  }

  wardChanged() {
    if (this.filter.wards.length < this.selectionWard.options.length) {
      this.allSelectedWard = false;
    } else {
      this.allSelectedWard = true;

    }
  }
}

function parseDateGetTime(dateTime: string) {
  const arrayDate = dateTime.split(' ');
  const date = arrayDate[0];
  const hour = arrayDate[1];

  if (hour)
    return new Date(date.split('/').reverse().join('/') + ' ' + hour).getTime();
  else {
    return new Date(date.split('/').reverse().join('/')).getTime();
  }
}

